import { DynamicQuestionnaireFields } from '@core/data-access/models/api/dynamic-questionnaire-fields.model';
import { createAction, createActionGroup, emptyProps } from '@ngrx/store';

export const AppInitializedAction = createAction('[App] Initialized');

export const AppFeatureActions = createActionGroup({
  source: 'App feature',
  events: {
    'Saved ticket holder feature added': emptyProps(),
    'Saved ticket holder feature removed': emptyProps(),
    'Buyer questionnaire feature added': (dynamicBuyerQuestionnaireFields: DynamicQuestionnaireFields) => ({
      dynamicBuyerQuestionnaireFields
    }),
    'Buyer questionnaire feature removed': emptyProps(),
    'Ticket assignment feature added': emptyProps(),
    'Ticket assignment feature removed': emptyProps()
  }
});
